<!--
 * @Author: 硪要滴幸福丶 542709122@qq.com
 * @Date: 2023-02-07 11:47:54
 * @LastEditors: 硪要滴幸福丶 542709122@qq.com
 * @LastEditTime: 2024-02-01 11:08:10
 * @FilePath: \vueproject\src\views\kami\Kami.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.kamiNo" placeholder="输入openid"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" >
      </el-table-column>
      <el-table-column sortable prop="id" label="序号" >
      </el-table-column>
      <el-table-column sortable prop="openid" label="openid" >
      </el-table-column>
      <el-table-column sortable prop="avatarUrl" label="头像" >
        <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.avatarUrl"
              :fit="fit"></el-image>
        </template>
      </el-table-column>
      <el-table-column sortable prop="nickName" label="昵称" >
      </el-table-column>
      <el-table-column sortable prop="kyCishu" label="可用次数" >
      </el-table-column>
      <el-table-column sortable prop="syCishu" label="已用次数" >
      </el-table-column>
      <el-table-column sortable prop="clickDate" label="签到日期" >
      </el-table-column>
      <el-table-column sortable prop="fenxiangDate" label="分享日期" >
      </el-table-column>
      <el-table-column sortable prop="status" label="状态" >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 0" size="small" type="success">正常</el-tag>
          <el-tag v-if="scope.row.status == 1" size="small" type="danger">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column sortable prop="create_time" label="创建日期" >
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="50px" :model="editForm" :rules="rules" ref="editForm">
        <!-- <el-form-item label="数量" prop="num">
          <el-input-number size="small" v-model="num" :min="1" :max="100" @change="numChange"></el-input-number>
        </el-form-item> -->
        <el-form-item label="类型" prop="type">
          <el-select size="small" v-model="editForm.type" placeholder="请选择类型" class="userRole" :change="typeChange(editForm.type)">
            <el-option label="次数" value="次数" ></el-option>
            <el-option label="会员" value="会员"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="次数" prop="cishu">
          <el-input-number size="small" v-model="cishu" :min="0" :max="1000" @change="handleChange" :disabled="cishuDisabled"></el-input-number>
        </el-form-item>
        <el-form-item label="vip" prop="vipDate">
            <el-date-picker
              v-model="vip"
              align="right"
              type="date"
              placeholder="请选择日期"
              :picker-options="pickerOptions"
              class="userRole"
              size="small"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              :change="pickerChange(vip)"
              :disabled="pickerDisabled">
            </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  KamiFindPageAllList,
  userUpdate,
  userDel,
  userPageAllList
} from '../../api/payMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      num:1,
      cishu:0,
      vip:'',
      editForm: {
        id: '',
        kami: '',
        type: '',
        num:1,
        cishu: 0,
        vipDate: '',
      },
      cishuDisabled:false,
      pickerDisabled:true,
      pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
          shortcuts: [{
            text: '周卡',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }, {
            text: '月卡',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 31);
              picker.$emit('pick', date);
            }
          }, {
            text: '半年卡',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 31 * 6);
              picker.$emit('pick', date);
            }
          }, {
            text: '年卡',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 31 * 12);
              picker.$emit('pick', date);
            }
          }]
        },
      // rules表单验证
      rules: {
        kami: [
          { required: true, message: '请输入卡密', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ],
        cishu: [
          { required: true, message: '请输入次数', trigger: 'blur' }
        ],
      },
      formInline: {
        page: 1,
        size: 10,
        kamiNo:'',
        // varLable: '',
        // varName: '',
      },
      // 删除部门
      seletedata: {
        ids: '',
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取卡密列表
    getdata(parameter) {
      this.loading = true
      userPageAllList(parameter)
        .then(res => {
          this.loading = false
          console.log(res)
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.total
        })
        .catch(err => {
          this.loading = false
          this.$message.error('系统异常，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.kami = row.kami
        this.editForm.type = row.type
        this.editForm.cishu = row.cishu
        this.editForm.vipDate = row.vipDate
      } else {
        this.title = '添加'
        this.editForm.kami = ''
        this.editForm.type = '次数'
        this.editForm.cishu = 0
        this.editForm.vipDate = ''
      }
    },
    typeChange(value){
        if(value == '次数'){
          this.editForm.vipDate = '';
          this.vip = '';
          this.cishuDisabled = false;
          this.pickerDisabled = true;
        }else{
          this.editForm.cishu = 0;
          this.cishu = 0;
          this.cishuDisabled = true;
          this.pickerDisabled = false;
        }
    },
    handleChange(value) {
        this.editForm.cishu = value;
    },
    numChange(value){
      console.log(value);
      this.editForm.num = value;
    },
    pickerChange(value){
        this.editForm.vipDate = value;
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          console.log(this.editForm)
          userUpdate(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.status) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: res.msg,
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('系统异常，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          userDel(row)
            .then(res => {
              // console.log(res);
              if (res.status) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('系统异常，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/user/WxUser.vue